import { render, staticRenderFns } from "./quotations-new-list.vue?vue&type=template&id=55aa2936&"
import script from "./quotations-new-list.vue?vue&type=script&lang=js&"
export * from "./quotations-new-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports